import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/250324/miras-le_mclaren25-miami-{nnn}.png',
}

export default {
  supports360: false,
  layers: [body],
  resolveOptions: () => ({}),
}
